import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar arquivos de tradução
import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';
import esES from './locales/es-ES.json';

// Configurar o i18next
i18n
  .use(initReactI18next) // Integração com React
  .init({
    // Recursos de tradução
    resources: {
      'pt-BR': {
        translation: ptBR
      },
      'en-US': {
        translation: enUS
      },
      'es-ES': {
        translation: esES
      }
    },
    
    // Idioma padrão
    lng: 'en-US', // Começa em inglês
    
    // Idioma fallback (se não encontrar tradução)
    fallbackLng: 'pt-BR',
    
    // Interpolação - permite usar variáveis nas traduções
    interpolation: {
      escapeValue: false // React já faz escape por padrão
    },
    
    // Debug no console (útil para desenvolvimento)
    debug: false
  });

export default i18n;
